<template>
    <article>
        <template v-for="(item, i) in dataList">
            <h3 v-if="item.type == 'h3'" class="margin-bottom-10">{{ item.content }}</h3>
            <Paragraph v-if="item.type == 'paragraph'" v-for="(paragraph, i) in item.content" :key="i"
                v-html="paragraph">
            </Paragraph>
            <ListDot v-if="item.type == 'list'" :list="item.content"></ListDot>
        </template>
    </article>
</template>

<script>
import ListDot from './ListDot.vue';
import Paragraph from './Paragraph.vue';

export default {
    components: {
        Paragraph,
        ListDot
    },
    props: {
        dataList: {
            type: Array,
        },
    },
}
</script>